const NOT_LOGIN_ADD_CART_ERROR = 'Please log in to add items to cart'

export { NOT_LOGIN_ADD_CART_ERROR }
